import React, {useState, useEffect, useContext, useCallback, useRef} from 'react';
import GridLayout from 'react-grid-layout';
import './css/StockTracking.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';  // Import Search Icon
import {fetchGUIInstrumentsByTabID} from '../services/GUIInstrumentService';
import {updateTickerSubscriptionWithKite} from "../services/apiService";
import {DataContext} from "../contexts/DataContext";  // You need to implement this function
import {handleSearch} from '../services/apiService';  // Adjust the path if necessary
import {updateGUIInstrumentsToBackend} from '../services/apiService'; // Import the new API function
/*import CustomArrowIcon from './components/CustomArrowIcon';*/
import ActionButtons from "@dashboard/stocktracking/components/ActionButtons";
import {useStateUpdatePermission} from "../contexts/StateUpdateContext";
import ExchangeButtons from '@dashboard/stocktracking/components/ExchangeButtons';
import StockTrackingRow from "@dashboard/stocktracking/components/StockTrackingRow";
import {fetchPositions} from "../services/apiService";
import WebSocketService from "../../websockets/WebSocketService";
import { useSharingContext } from '../contexts/SharingContext';
import {
    handleAddPosition, handleAddPositionFromSearchBar,
    handleAddToOldGrid,
    handleDeleteFromOldGrid,
    handleDeletePosition
} from "@marketwatch/gridcomponents/util/GridOperations";
import {handleShowDetails} from "./components/MoreDetails/MoreDetailsOperations";
import {TickProvider, useTickContext} from "../contexts/TickContext";
import SearchItemRow from "@dashboard/stocktracking/components/SearchItemRow";

const StockTracking = () => {
    const [newRowAdded, setNewRowAdded] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredInstruments, setFilteredInstruments] = useState([]);
    const {allInstrumentsList} = useContext(DataContext);
    const [newGridVisible, setNewGridVisible] = useState(false); // State to control new grid visibility
    const [draggingItem, setDraggingItem] = useState(null);
    const {canUpdateState, setCanUpdateState} = useStateUpdatePermission(); // Access state and setter
    const gridLayoutRef = useRef(null);
    const moreDetailsLayoutRef = useRef(null); // Define the ref in a React component
    const rowHeightGridLayout = 45;
    const { currentlyHeldPositions,setCurrentlyHeldPositions,SharingContextLoading,PosGridlayouts, setPosGridlayouts,PosGridTabID } = useSharingContext();
    const tickContext = useTickContext();
    const tick = tickContext?.tick || {}; // Use an empty object if tick is undefined
    /*const changeSubscriptionModeToDetail = tickContext?.changeSubscriptionModeToDetail || (() => {});*/
    const tabID=10;

    useEffect(() => {
        const load = async () => {
            try {
                const res = await fetchPositions();
                setCurrentlyHeldPositions(res);

                const layouts = res.map((position,index) => ({
                    i: `${tabID}-${position.instrumentToken}`,
                    x: 0,
                    y: index,  // Use sequenceNumber for y value
                    w: 1,
                    h: 1,
                }));
                setPosGridlayouts(layouts);
            } catch (e) {
                console.error("Failed loading positions", e);
            }
        };

        load();
    }, []);

    const handleDragStop = (layout, oldItem, newItem) => {
        setPosGridlayouts(layout);

        const orderedTokens = layout
            .slice()
            .sort((a, b) => a.y - b.y)
            .map(item => Number(item.i.split(`${tabID}-`)[1]));

        const updatedInstruments = orderedTokens.map((token, idx) => {
            const inst = currentlyHeldPositions.find(p => p.instrumentToken === token);
            return { ...inst, sequenceNumber: idx, tabID };
        });

        setCurrentlyHeldPositions(updatedInstruments);
        updateGUIInstrumentsToBackend(updatedInstruments, tabID);
        updateTickerSubscriptionWithKite(updatedInstruments, tabID);

        // ❌ DON'T call setPosGridlayouts again here
    };

    useEffect(() => {
        handleSearch(searchQuery, allInstrumentsList, setFilteredInstruments);
    }, [searchQuery]);

    useEffect(() => {
        /*console.log('newGridVisible',newGridVisible);*/
        setNewGridVisible(filteredInstruments.length > 0);
        /*console.log('newGridVisible',newGridVisible);*/
    }, [filteredInstruments]);

    const handleEscape = (event) => {
        if (event.key === 'Escape') {
            setNewGridVisible(false);
            setSearchQuery('');
        }
    };

    useEffect(() => {
        if (newGridVisible) {
            document.addEventListener('keydown', handleEscape);
        } else {
            document.removeEventListener('keydown', handleEscape);
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [newGridVisible]);

    useEffect(() => {
                // Subscribe to WebSocket for reloadAllInstruments message
        WebSocketService.subscribe('refreshPositions', null, (message) => {
            try {
                // Assuming the message contains the list of positions as JSON
                const updatedPositions = message.content;

                // Validate the positions if necessary
                if (Array.isArray(updatedPositions)) {
                    setCurrentlyHeldPositions(updatedPositions); // Update state with new positions
                } else {
                    console.error('Invalid data format for positions:', message.data);
                }
            } catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        });

    }, []);

    // Function to update price difference for each instrument
    const handlePriceDifferenceUpdate = (instrumentToken, priceDifference) => {
        if (canUpdateState) {
            setCurrentlyHeldPositions((prevInstruments) =>
                prevInstruments.map(instrument => {
                    if (instrument.instrumentToken === instrumentToken) {
                        return {...instrument, priceDifferencePercentage: priceDifference};
                    }
                    return instrument;
                })
            );
        }
    }

    // Dynamically calculate rowHeight and total grid height
    const rowHeightNewGridLayout = 36; // Assume each row is 40px high
    const calculateGridHeight = () => {
        const itemCount = filteredInstruments.length;
        return itemCount > 0 ? (itemCount) * rowHeightNewGridLayout : rowHeightNewGridLayout;  // Set height based on the number of items
    };
    if (SharingContextLoading) {
        return <p>Loading positions...</p>;  // Display loading indicator
    }


    return (
        <div className={'st-grid-holder'}>
            <div className="resizable-container-st">
                <div className="stocktracking-wrapper">
                    <div className="stocktracking-container">
                    <div className="st-search-input-container">
                        <div className="search-button-1">
                            <Button
                                variant="contained"
                                color="default">
                                <SearchIcon/>
                            </Button>
                        </div>
                        <input
                            type="text"
                            placeholder='Search trading token'
                            value={searchQuery}
                            onChange={(e) => {
                                const query = e.target.value;
                                /*console.log('setting SearchQuery to: ', query);*/
                                setSearchQuery(query);
                            }}
                            className="search-input-box"
                        />
                    </div>
                    <div className="st-header-container">
                        <div className="st-header-div">
                            <span className="span-token-st">Symbol</span>
                            <span className="span-change-st">Change%</span>
                            <span className="span-buyavg-st">BuyAvg</span>
                            <span className="span-ltp-st">LTP</span>
                            <span className="span-pnl-perc-st">PnL%</span>
                        </div>
                    </div>

                    {newGridVisible && (
                        <GridLayout
                            className="new-grid-layout"
                            cols={1}
                            rowHeight={rowHeightNewGridLayout}  // Set the row height
                            width={100}
                            isResizable={false}
                            isDraggable={false}
                            /*compactType={null}*/
                            preventCollision={true}
                            margin={[0, 0]}  // Set margin to 0 between items
                            style={{height: `${calculateGridHeight()}px`}}  // Set dynamic height based on number of items
                        >
                            {filteredInstruments.map((instrument, index) => {
                                // Check if the instrument is in the currentlyHeldPositions state
                                const isExistingInGrid = currentlyHeldPositions.some(guiInstrument => guiInstrument.instrumentToken === instrument.instrumentToken);
                                /*{console.log(instrument.tradingsymbol)}*/
                                            return (
                                                <SearchItemRow
                                                    key={index}
                                                    instrument={instrument}
                                                    isExistingInGrid={isExistingInGrid}
                                                    handleAddPositionFromSearchBar={handleAddPositionFromSearchBar}
                                                    currentlyHeldPositions={currentlyHeldPositions}
                                                    setCurrentlyHeldPositions={setCurrentlyHeldPositions}
                                                    tabID={tabID}
                                                    tick={tick}
                                                    PosGridlayouts={PosGridlayouts}
                                                    setPosGridlayouts={setPosGridlayouts}
                                                    PosGridTabID={PosGridTabID}
                                                 />
                                            );
                                        })}
                         </GridLayout>
                                )
                            }

                    {/* Old Grid Layout */}
                <div ref={gridLayoutRef} className="grid-layout-wrapper grid-layout-wrapper-st">
                    <GridLayout
                        className="grid-layout grid-layout-st"
                        layout={PosGridlayouts}  // Layout prop controlling item positions
                        cols={1}
                        rowHeight={rowHeightGridLayout}
                        isResizable={false}
                        isDraggable={true}
                        margin={[0, 0]}
                        containerPadding={[0, 0]}
                        width={400}
                        onDragStop={handleDragStop}  // Update layout on drop
                        draggableCancel="
                        .symbol_n_exchange-st,
                        .actions-st,
                        .actions-st *
                    "
                    >

                        {PosGridlayouts
                            /*.sort((a, b) => a.y - b.y)*/
                            .map((layout, index) => {
                                const position = currentlyHeldPositions.find(
                                    (position) => `${tabID}-${position.instrumentToken}` === layout.i
                                );
                                return (
                                    <div
                                        key={layout.i}
                                        className="grid-item"
                                    >
                                        {position ? (
                                            <>
                                                <StockTrackingRow
                                                    trackedStock={position}
                                                    uniqueId={layout.i}
                                                    onPriceDifferenceUpdate={handlePriceDifferenceUpdate}
                                                    setLayouts={setPosGridlayouts}
                                                    layoutIndex={index}
                                                />
                                                <ActionButtons
                                                    onDelete={handleDeletePosition}
                                                    instrumentToken={position.instrumentToken}
                                                    GUIInstruments={position}
                                                    setGUIInstruments={setCurrentlyHeldPositions}
                                                    setStockTrackGridlayouts={setPosGridlayouts}
                                                    tabID={tabID}
                                                    onShowDetails={() =>
                                                        handleShowDetails(position, setCurrentlyHeldPositions, setPosGridlayouts, tabID, index, 10.8)
                                                    }
                                                    PosGridlayouts={PosGridlayouts}
                                                />
                                            </>
                                        ) : (
                                            <div>No Instrument Found</div>
                                        )}
                                    </div>
                                );
                            })}
                    </GridLayout>
                </div>
                    </div>
                </div>
            </div>
        </div>
            );
            };

            export default StockTracking;
